export function formatCurrency(balance: number, currency = 'USD', locale = 'en-US') {
  const _currency = currency ?? 'USD'
  const _locale = locale ?? 'en-US'
  return new Intl.NumberFormat(_locale, {
    currency: _currency,
    style: 'currency',
  }).format(balance)
}
